<template>
  <v-expansion-panels focusable>
    <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
      <v-expansion-panel-header>
        <v-row class="pa-0 align-center">
          <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 mt-0`">
            <v-chip small label color="secondary" style="text-transform:uppercase;">{{r.type.split('_').join(' ')}}</v-chip>
          </v-col>
          <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{r.name}}</span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.title}}</div>
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.sub_title}}</div>
              </div>
            </v-tooltip>
          </v-col>
          
          <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 mt-0`">
          </v-col>
          <v-col cols="12" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 mt-0 text-center`">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" 
                  x-small @click.stop="edit(r)">
                  <v-icon left size="12">create</v-icon>
                  {{i18n.editIconTooltip}}
                </v-btn>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                {{i18n.editIconTooltip}}
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider class="pb-3"></v-divider>
        <v-row class="pa-0 align-center">
          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-1`">
            
          </v-col>
          <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
            <v-btn color="error" block text @click="updateResource(r)">
              <v-icon left>close</v-icon>
              <span :class="`${arabic?'arFont':'enFont'}`">
                {{ i18n.delete }}
              </span>
            </v-btn>
          </v-col>
          <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
            <v-btn color="success" block text @click="updateResource(r)">
              <v-icon left>save</v-icon>
              <span :class="`${arabic?'arFont':'enFont'}`">
                {{ i18n.update }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props:['resourceSettings', 'resource' , 'resourceKeys', 'match'],
  methods:{
    openLink(url) {
      window.open(url, '_blank');
    },
    getColor(status) {
      if(status == 'new') {
        return 'success'
      } else
      if(status == 'to_create') {
        return '#9c27b0'
      } else
      if(status == 'confirmed') {
        return 'primary'
      } else
      if(status == 'interview') {
        return '#8bc34a'
      } else
      if(status == 'accepted') {
        return '#00bcd4'
      } else
      if(status == 'need_follow_up' || status == 'out_of_reach') {
        return "#FFC107"
      } else {
        return 'error'
      }
    },
    edit(r) {
      this.$emit('editItem', r)
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    user(){
      return this.$store.state.user
    },

  }
}
</script>

<style>

</style>